export const config = {
  channelName: process.env.REACT_APP_CHANNEL_NAME || "",
  apiUrl: process.env.REACT_APP_API_URL || "",
  ipex: {
    videoFlagship: process.env.REACT_APP_IPEX_VIDEO_FLAGSHIP || "",
    videoScrapRecycling: process.env.REACT_APP_IPEX_VIDEO_SCRAP_RECYCLING || "",
    videoMetalCloud: process.env.REACT_APP_IPEX_VIDEO_METAL_CLOUD || "",
    videoFinance: process.env.REACT_APP_IPEX_VIDEO_FINANCE || "",
  },
  // Careers job listings are served by our own server (Netlify Function in prod,
  // src/setupProxy.js locally) at this same-origin path. That server owns the
  // Keka Hire integration and token; the frontend never talks to Keka directly
  // and no Keka credentials ship in the bundle (PRD FR-2).
  careersJobsPath: "/api/public/careers/jobs/",
};
